<header class="header">403 Forbidden</header>

<p class="header-text">Sorry, not sorry. The page you are trying to access is restricted.</p>

<button mat-stroked-button [routerLink]="nav_path.home" type="button">Take Me Home</button>
